function constructViewBox(svg) {
	const width = svg.getAttribute('width');
	const height = svg.getAttribute('height');
	svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
}

function getSvgBoxSize($svg) {
	if (!$svg[0].getAttribute('viewBox')) {
		constructViewBox($svg[0]);
	}
	const values = $svg[0].getAttribute('viewBox').split(' ');

	return {
		width: Number(values[2]),
		height: Number(values[3])
	};
}

function getFittedSvgSize($svg, containerSize) {
	const svgBoxSize = getSvgBoxSize($svg);
	return getFittedSize(svgBoxSize, containerSize);
}

// Получает размер элемента, подогнанный под размер контейнера
function getFittedSize(elementSize, containerSize) {
	if (containerSize.width && containerSize.height) {
		const elementRatio = elementSize.width / elementSize.height;
		const containerRatio = containerSize.width / containerSize.height;
		if (elementRatio >= containerRatio) {
			return getFittedByWidthSize(elementSize, containerSize.width);
		} else {
			return getFittedByHeightSize(elementSize, containerSize.height);
		}
	} else if (containerSize.width) {
		return getFittedByWidthSize(elementSize, containerSize.width);
	} else if (containerSize.height) {
		return getFittedByHeightSize(elementSize, containerSize.height);
	} else {
		console.error('Не определены width и height в параметре containerSize');
		return elementSize;
	}
}

// Получает размер элемента, подогнанный под ширину контейнера
function getFittedByWidthSize(elementSize, containerWidth) {
	let newHeight = containerWidth / elementSize.width * elementSize.height;
	newHeight = Math.round(newHeight * 10) / 10;
	return {
		width: containerWidth,
		height: newHeight
	};
}

// Получает размер элемента, подогнанный под высоту контейнера
function getFittedByHeightSize(elementSize, containerHeight) {
	let newWidth = containerHeight / elementSize.height * elementSize.width;
	newWidth = Math.round(newWidth * 10) / 10;
	return {
		width: newWidth,
		height: containerHeight
	};
}

// Растягивает SVG по ширине внешнего контейнера (включая IE-костыли)
function fitSvgSizeToWidth($container, $svg) {
	const svgBoxSize = getSvgBoxSize($svg);
	const svgRatio = svgBoxSize.width / svgBoxSize.height;
	const ratioWindow = $(window).width() / $(window).height();
	var ratio = svgBoxSize.height / svgBoxSize.width * 100;

	if ($container.data('fit') === 'both') {
		const containerRatio = $container.parent().width() / $container.parent().height();
		if (svgRatio <= containerRatio) {
			ratio = 0;
			$container.css('height', '100%');
		}
	} else if ($container.data('fit') === 'height') {
		ratio = 0;
		$container.css('height', '100%');
	}

	$container
		.css('position', 'relative')
		.attr('height', '0')
		.attr('width', '100%')
		.css('padding', '0')
		.css('padding-bottom', ratio + '%')
		.attr('data-ratio', svgRatio);

	$svg
		.css('position', 'absolute')
		.attr('width', '100%')
		.attr('height', '100%')
		.css('left', '0')
		.css('top', '0');
}

module.exports.getSvgBoxSize = getSvgBoxSize;
module.exports.getFittedSvgSize = getFittedSvgSize;
module.exports.getFittedSize = getFittedSize;
module.exports.fitSvgSizeToWidth = fitSvgSizeToWidth;



// WEBPACK FOOTER //
// ./temp/components/svg/svgSize.js